export default __webpack_public_path__ + "static/media/phil_pallen.3d8ef742.png";